'use client';
'use strict';

var _tslib = require('../../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
var react = require('react');

const RadioButton = ({ isDisabled, isSelected = false, isError, className })=>{
    const generateStyles = ()=>{
        // 체크되었고 비활성화 상태의 경우
        if (isSelected && isDisabled) return 'bg-w-white border-primary-100 cursor-not-allowed';
        // 비활성화 상태의 경우
        if (isDisabled) return 'bg-w-gray-50 border-w-gray-200 cursor-not-allowed';
        // 활성화 상태에서 체크되었고 오류가 없는 경우
        if (isSelected && !isError) return 'bg-w-white border-primary-500';
        // 활성화 상태에서 체크되었고 오류가 있는 경우
        if (isSelected && isError) return 'bg-w-white border-w-red-500';
        // 활성화 상태에서 체크되지 않았고 오류가 있는 경우
        if (!isSelected && isError) return 'border-w-red-500';
        // 위의 어떤 조건에도 해당하지 않을 경우 (기본 스타일)
        return 'bg-white border-w-gray-200 group-hover:border-primary-500 cursor-pointer';
    };
    return jsxRuntime.jsx("div", {
        className: tailwindMerge.twMerge('relative box-border flex h-[18px] w-[18px] items-center justify-center rounded-full border p-[4px]', generateStyles(), className),
        role: "radio-button",
        children: jsxRuntime.jsx("div", {
            className: tailwindMerge.twMerge('size-2 rounded-full bg-primary transition-all duration-100 ease-in-out', !isSelected && 'h-0 w-0', isError && 'bg-w-red-500', isDisabled && 'bg-w-gray-200', isSelected && isDisabled && 'bg-primary-100')
        })
    });
};
/**
 * 사용자가 여러 옵션 중 하나를 선택할 수 있는 라디오 버튼 컴포넌트입니다.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.value=''] - 라디오 버튼의 값
 * @param {boolean} [props.isSelected=false] - 라디오 버튼의 선택 상태
 * @param {boolean} [props.isDisabled=false] - 라디오 버튼의 비활성화 상태
 * @param {boolean} [props.isError=false] - 라디오 버튼의 에러 상태
 * @param {string} [props.className] - 추가적인 스타일링을 위한 클래스명
 *
 * @example
 * // 기본 사용
 * <Radio value="option1" />
 *
 * // 선택된 상태
 * <Radio value="option2" isSelected={true} />
 *
 * // 비활성화 상태
 * <Radio value="option3" isDisabled={true} />
 *
 * // 에러 상태
 * <Radio value="option4" isError={true} />
 *
 * // 커스텀 스타일
 * <Radio value="option5" className="custom-radio" />
 */ const Radio = react.forwardRef((_a, ref)=>{
    var { value = '', isSelected = false, isDisabled = false, isError = false, className } = _a, rest = _tslib.__rest(_a, [
        "value",
        "isSelected",
        "isDisabled",
        "isError",
        "className"
    ]);
    return jsxRuntime.jsxs("label", {
        "data-testid": "design-system-radio",
        className: "group cursor-pointer",
        children: [
            jsxRuntime.jsx("input", Object.assign({
                ref: ref,
                type: "radio",
                className: "hidden",
                value: value,
                checked: isSelected,
                disabled: isDisabled
            }, rest)),
            jsxRuntime.jsx(RadioButton, {
                isSelected: isSelected,
                isError: isError,
                isDisabled: isDisabled,
                className: className
            })
        ]
    });
});
Radio.displayName = 'Radio';

module.exports = Radio;
